(function () {
  "use strict";

  const MOBILE_BREAKPOINT = 768;
  const BOTTOM_OFFSET_MOBILE = "130px";
  const BOTTOM_OFFSET_DESKTOP = "90px";

  function applyOffset() {
    const cmp = document.querySelector("pandectes-cmp");
    if (!cmp || !cmp.shadowRoot) return;
    const btn = cmp.shadowRoot.querySelector("button.widget");
    if (!btn) return;

    const offset = window.innerWidth <= MOBILE_BREAKPOINT
      ? BOTTOM_OFFSET_MOBILE
      : BOTTOM_OFFSET_DESKTOP;
    btn.style.setProperty("bottom", offset, "important");
    /* R77: Bei offenem Warenkorb-Drawer lag das Symbol (bottom 130 px) auf
       dem Drawer-Fuss und verdeckte "Priorisierter Versand". Solange der
       Drawer offen ist, wird es ausgeblendet; danach ist es wieder da. */
    const drawer = document.querySelector("cart-drawer");
    const drawerOffen = !!drawer && drawer.classList.contains("active");
    btn.style.setProperty("visibility", drawerOffen ? "hidden" : "visible", "important");
  }

  /* Runde 72: Der Cookie-Banner liegt unten ueber dem Kaufweg (375 px:
     215 px hoch, "Akzeptieren" genau dort, wo Groessen-Kacheln und
     "Zur Kasse" sitzen). Gemessen wird die sichtbare Hoehe des Banners
     vom oberen Rand bis zum Viewport-Ende; sie landet als --dz-cmp-h auf
     <html>. Drawer-Fuss, Sticky-Kaufleiste, WhatsApp-Knopf und das
     Seitenende ruecken um genau diesen Wert nach oben. Banner-Inhalt und
     Pandectes-Einstellungen bleiben unberuehrt, ebenso sein z-index -
     er bleibt oben und bedienbar. Ist er zu, steht der Wert auf 0px. */
  let lastHeight = -1;
  let observedBanner = null;
  const resizeObserver = "ResizeObserver" in window ? new ResizeObserver(() => measureBanner()) : null;

  function findBanner(root) {
    let best = null;
    let bestHeight = 0;
    root.querySelectorAll(".dialog, [role=dialog], [class*=banner], [class*=notice]").forEach((el) => {
      const s = getComputedStyle(el);
      if (s.position !== "fixed" || s.display === "none" || s.visibility === "hidden" || parseFloat(s.opacity) === 0) return;
      const r = el.getBoundingClientRect();
      // nur was unten am Rand anliegt und nennenswert hoch ist
      if (r.height < 40 || r.bottom < window.innerHeight - 4) return;
      if (r.height > bestHeight) { best = el; bestHeight = r.height; }
    });
    return best;
  }

  function measureBanner() {
    const cmp = document.querySelector("pandectes-cmp");
    const banner = cmp && cmp.shadowRoot ? findBanner(cmp.shadowRoot) : null;
    let height = 0;
    if (banner) {
      const r = banner.getBoundingClientRect();
      height = Math.max(0, Math.round(window.innerHeight - r.top));
      if (resizeObserver && observedBanner !== banner) {
        if (observedBanner) resizeObserver.unobserve(observedBanner);
        resizeObserver.observe(banner);
        observedBanner = banner;
      }
    }
    if (height === lastHeight) return;
    lastHeight = height;
    const root = document.documentElement;
    root.style.setProperty("--dz-cmp-h", height + "px");
    root.classList.toggle("dz-cmp-offen", height > 0);
  }

  // Der Banner faehrt mit einer Animation ein und aus - kurz nachmessen.
  function measureSoon() {
    measureBanner();
    setTimeout(measureBanner, 350);
    setTimeout(measureBanner, 900);
  }

  function update() {
    applyOffset();
    measureSoon();
  }

  // Initial run (when Pandectes is already loaded)
  update();

  // R77: Drawer auf/zu -> Sichtbarkeit des Symbols nachziehen
  function drawerBeobachten() {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer || drawer.__dzCmpObserved) return;
    drawer.__dzCmpObserved = true;
    new MutationObserver(applyOffset).observe(drawer, { attributes: true, attributeFilter: ["class"] });
  }
  drawerBeobachten();
  document.addEventListener("DOMContentLoaded", drawerBeobachten);

  // Resize listener — debounced
  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(update, 150);
  });

  // MutationObserver für async-geladenes Pandectes (App-Embed lädt nach DOM-Ready)
  const docObserver = new MutationObserver(() => {
    const cmp = document.querySelector("pandectes-cmp");
    if (!cmp || !cmp.shadowRoot) return;
    update();
    // Shadow auch beobachten — Widget kann später erscheinen (nach Banner-Click)
    if (!cmp.shadowRoot.__dzObserved) {
      cmp.shadowRoot.__dzObserved = true;
      new MutationObserver(update).observe(cmp.shadowRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        // "style" bewusst nicht: applyOffset setzt selbst einen Inline-Style
        // im Shadow-Root, das gaebe eine Rueckkopplung.
        attributeFilter: ["class", "hidden", "open"],
      });
      docObserver.disconnect();
    }
  });
  docObserver.observe(document.body, { childList: true, subtree: true });
})();
